import {
  allowlistedKnowledgeUri,
  knowledgePathDisplay,
} from './support-agent-sources';

export type SupportAgentContentPart =
  | { type: 'text'; value: string }
  | { type: 'link'; href: string; label: string };

const MORE_DETAILS_MARKER = 'More Details:';
const URL_PATTERN = /https:\/\/[^\s]+/g;

/** Drops the model-written More Details URL list. Related Links use citation sources. */
export function stripMoreDetailsSection(content: string): string {
  const markerIndex = content.indexOf(MORE_DETAILS_MARKER);
  if (markerIndex === -1) {
    return content;
  }
  return content.slice(0, markerIndex).trimEnd();
}

export function parseSupportAgentMessageContent(
  content: string
): SupportAgentContentPart[] {
  return tokenizeUrls(stripMoreDetailsSection(content), (href) =>
    knowledgePathDisplay(href)
  );
}

function tokenizeUrls(
  text: string,
  labelFor: (href: string) => string
): SupportAgentContentPart[] {
  const parts: SupportAgentContentPart[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(URL_PATTERN)) {
    const raw = match[0];
    const index = match.index ?? 0;
    if (index > lastIndex) {
      pushPart(parts, { type: 'text', value: text.slice(lastIndex, index) });
    }

    const href = allowlistedKnowledgeUri(raw);
    if (href) {
      pushPart(parts, { type: 'link', href, label: labelFor(href) });
    } else {
      pushPart(parts, { type: 'text', value: raw });
    }
    lastIndex = index + raw.length;
  }

  if (lastIndex < text.length) {
    pushPart(parts, { type: 'text', value: text.slice(lastIndex) });
  }

  return parts;
}

function pushPart(
  parts: SupportAgentContentPart[],
  part: SupportAgentContentPart
) {
  if (part.type === 'text' && part.value === '') {
    return;
  }
  const last = parts[parts.length - 1];
  if (part.type === 'text' && last?.type === 'text') {
    last.value += part.value;
    return;
  }
  parts.push(part);
}
